var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckRoundSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7502 5.70814L7.5388 8.91964L6.24971 7.63056C6.24971 7.63055 6.2497 7.63054 6.2497 7.63054C5.99713 7.37787 5.58755 7.37786 5.33498 7.63052C5.33497 7.63053 5.33497 7.63053 5.33496 7.63054C5.33495 7.63054 5.33495 7.63055 5.33494 7.63056C5.08228 7.88312 5.08229 8.29271 5.33496 8.54527C5.33496 8.54528 5.33497 8.54529 5.33498 8.54529L7.08143 10.2919L7.08145 10.2919C7.33412 10.5444 7.74359 10.5444 7.99626 10.2919L7.99628 10.2919L11.665 6.623C11.665 6.623 11.665 6.62299 11.665 6.62299C11.9177 6.3704 11.9177 5.9608 11.665 5.70814C11.4125 5.45557 11.0029 5.45559 10.7502 5.70813L10.7502 5.70814ZM8.5 15.1C12.4239 15.1 15.6 11.9245 15.6 8C15.6 4.07606 12.4245 0.9 8.5 0.9C4.57606 0.9 1.4 4.07552 1.4 8C1.4 11.9239 4.57552 15.1 8.5 15.1ZM8.5 2.19375C11.709 2.19375 14.3062 4.79054 14.3062 8C14.3062 11.209 11.7095 13.8062 8.5 13.8062C5.29096 13.8062 2.69375 11.2095 2.69375 8C2.69375 4.79096 5.29054 2.19375 8.5 2.19375Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckRoundSmall);
export default __webpack_public_path__ + "static/media/check-round-small.36e62875349c33af258efe5ab5ee60c4.svg";
export { ForwardRef as ReactComponent };